import React from 'react';

export default function Graph308(props) {

    let {a, b, c} = props.data;
    
    props.board.create('functiongraph',[function(x){return a*Math.abs(x - b) + c}],{strokeColor:'black',highlightStrokeColor:'black'});
    
    return <></>
}